<section
  class="flex flex-wrap w-full lt-xl:w-full flex-col flex flex-col flex-auto bg-card shadow-md rounded overflow-hidden"
>
  <header class="flex flex-col w-full" id="table-header" #tableHeader>
    <div class="flex justify-between items-center p-4">
      <mat-checkbox
        [color]="'primary'"
        [checked]="includeSelected"
        (change)="showSelectedComps($event)"
        *ngIf="isCompsetStatic"
      >
        Show all selected {{ displayType | pluralize }}
      </mat-checkbox>
      <div class="flex items-end gap-2 ml-auto">
        @if (hasDistMilesColumn()) {
          <ts-input
            type="number"
            icon="map"
            name="miles"
            [formControl]="miles"
            label="Distance (miles)"
            [appAuthorize]="canEditDeal()"
            denyAction="disable"
          ></ts-input>
        }
        <ts-button
          class="mt-1"
          icon="filter_alt"
          color="accent"
          type="stroked"
          [tsOverlayTriggerFor]="overlayBox"
          [appAuthorize]="canEditDeal()"
          denyAction="disable"
        >
          Filter
          <ts-badge
            *ngIf="filterValueList.value?.length"
            [value]="filterValueList.value?.length"
            type="info"
          ></ts-badge>
        </ts-button>

        <ts-button
          class="mt-1"
          (click)="save()"
          [disabled]="isCompsetStatic ? selectedCompIds.length === 0 : !filterChanged"
          [appAuthorize]="canEditDeal()"
          denyAction="disable"
        >
          Save
        </ts-button>

        @if (isCompsetStatic) {
          <ts-button type="stroked" (click)="discard()" [appAuthorize]="canEditDeal()" denyAction="disable">
            <ts-icon [icon]="'close'"></ts-icon>
            Cancel Edit
          </ts-button>
        }
      </div>
    </div>
  </header>

  <main class="overflow-auto w-full" *ngIf="dataSource?.data.length > 0 || isLoading(); else emptyComps">
    @if (isLoading()) {
      <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
    }
    <table
      class="w-full bg-transparent"
      [ngClass]="{ 'table-loading': isLoading() }"
      mat-table
      matSort
      [matSortActive]="sortBy"
      [matSortDirection]="sortDirection"
      [dataSource]="dataSource"
      [trackBy]="trackByFn"
      (matSortChange)="announceSortChange($event)"
    >
      <ng-container matColumnDef="index">
        <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t pl-2" mat-header-cell *matHeaderCellDef>
          <app-column-selector
            [matTooltip]="'Select columns'"
            [items]="compsetFieldDefs"
            [selectedOrder]="selectedOrder"
            [draggable]="true"
            (onSave)="saveColumn($event)"
          ></app-column-selector>
        </th>
        <td mat-cell *matCellDef="let comp">
          {{ comp.index }}
        </td>
      </ng-container>

      <ng-container matColumnDef="selected">
        <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell mat-sort-header *matHeaderCellDef>
          <span class="whitespace-nowrap"></span>
        </th>
        <td mat-cell *matCellDef="let comp">
          <span class="whitespace-nowrap">
            <button (click)="toggleSelected(comp)" mat-icon-button>
              <mat-icon *ngIf="comp.selected" [svgIcon]="'check_box'" [color]="'primary'"></mat-icon>
              <mat-icon *ngIf="!comp.selected" [svgIcon]="'check_box_outline_blank'"></mat-icon>
            </button>
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell mat-sort-header *matHeaderCellDef>
          <span class="whitespace-nowrap">Name</span>
        </th>
        <td mat-cell *matCellDef="let comp">
          <a
            *ngIf="compset.object_type === 'Project'"
            [routerLink]="['/projects/' + comp.pipeline_id + '/' + comp.id]"
            target="_blank"
          >
            <span class="pr-6 font-medium text-sm text-secondary whitespace-nowrap">
              {{ comp.name }}
            </span>
          </a>
          <a *ngIf="compset.object_type === 'Property'" [routerLink]="['/properties/' + comp.id]" target="_blank">
            <span class="pr-6 font-medium text-sm text-secondary whitespace-nowrap">
              {{ comp.name }}
            </span>
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="address">
        <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell mat-sort-header *matHeaderCellDef>
          <span class="whitespace-nowrap">Address</span>
        </th>
        <td mat-cell *matCellDef="let comp">
          <a
            *ngIf="compset.object_type === 'Project'"
            [routerLink]="['/projects/' + comp.pipeline_id + '/' + comp.id]"
            target="_blank"
          >
            <span class="pr-6 font-medium text-sm text-secondary whitespace-nowrap">
              {{ comp.address_string }}
              <br />
              {{ comp.property_type_name }}
            </span>
          </a>
          <a *ngIf="compset.object_type === 'Property'" [routerLink]="['/properties/' + comp.id]" target="_blank">
            <span class="pr-6 font-medium text-sm text-secondary whitespace-nowrap">
              {{ comp.address_string }}
              <br />
              {{ comp.property_type_name }}
            </span>
          </a>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="column" *ngFor="let column of getTableColumns(); index as i">
        <ng-container *ngIf="lookupField(column) as fieldDef">
          <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell mat-sort-header *matHeaderCellDef>
            <span class="whitespace-nowrap">
              {{ fieldDef.label }}
            </span>
          </th>
          <td mat-cell *matCellDef="let comp">
            <span class="pr-6 whitespace-nowrap">
              <ng-container *ngIf="fieldDef.type === 'money'">
                {{ comp[column] | tsCurrency: 'USD' : 'symbol' : '1.0' }}
              </ng-container>
              <ng-container *ngIf="fieldDef.type === 'percent'">
                {{ comp[column] / 100 | percent: '1.2-2' }}
              </ng-container>
              <ng-container *ngIf="fieldDef.type === 'number'">
                {{ comp[column] | number: '1.0-0' }}
              </ng-container>
              <ng-container *ngIf="fieldDef.type === 'decimal'">
                <!-- Add two digit decimal for dist_miles fieldDef only. -->
                @if (fieldDef.name === 'dist_miles') {
                  {{ comp[column] | number: '1.2-2' }}
                } @else {
                  {{ comp[column] | number: '1.1-1' }}
                }
              </ng-container>
              <ng-container *ngIf="fieldDef.type === 'select'">
                {{ getOptionName(fieldDef, comp[column]) }}
              </ng-container>
              <ng-container *ngIf="fieldDef.type === 'datetime' || fieldDef.type === 'date'">
                {{ comp[column] | date: 'MM/dd/yyyy' }}
              </ng-container>
              <ng-container *ngIf="isFieldTypeAllowed(fieldDef)">
                {{ comp[column] }}
              </ng-container>
            </span>
          </td>
        </ng-container>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="_displayColumns"></tr>
      <tr
        class="order-row h-16"
        [ngClass]="{ 'selected-row': property && row.property_id === property.id }"
        mat-row
        *matRowDef="let row; columns: _displayColumns"
      ></tr>
    </table>
  </main>

  <footer>
    <mat-paginator
      [length]="pagination.length"
      [pageIndex]="pagination.page"
      [pageSize]="pagination.size"
      [pageSizeOptions]="[5, 10, 25, 100]"
      (page)="page($event)"
      [showFirstLastButtons]="true"
    ></mat-paginator>
  </footer>
</section>

<ng-template #emptyComps>
  <section class="flex flex-col w-full items-center my-12">
    <h5>No results</h5>
  </section>
</ng-template>

<ts-overlay #overlayBox position="bottom" [transparentBackdrop]="true">
  <ts-filter
    size="large"
    [fields]="typeFields | async"
    [filters]="filterValueList | async"
    [hasGroups]="false"
    [lookupContract]="lookupService"
    (addItem)="onAddFilterItem()"
    (filterDefChange)="onFilterDefChanged($event)"
    (filterRemove)="onFilterRemoved($event)"
    (filterClear)="onFilterCleared()"
    (filterApply)="onFilterApplied()"
  >
  </ts-filter>
</ts-overlay>
